import {Button, Card, Col, FormControl, FormGroup, Row} from 'react-bootstrap';
import DateTime from 'react-datetime';
import MultiSelect from '../../../common/form/multi-select';

const PointsTransactionsSearch = props => (
  <Card className="order-filter admin-search-filter">
    <Card.Body>
      <Row>
        <Col md={4}>
          <FormGroup>
            <FormControl
              onChange={props.onInputChange}
              placeholder="Enter customer number"
              value={props.searchValue}
            />
          </FormGroup>
        </Col>
        <Col md={4}>
          <FormGroup>
            <DateTime
              closeOnSelect
              dateFormat="DD/MM/YYYY"
              inputProps={{
              placeholder: 'Date from'
            }}
              onChange={props.onDateFromChange}
              timeFormat={false}
              value={props.dateFromValue}
            />
          </FormGroup>
        </Col>
        <Col md={4}>
          <FormGroup>
            <DateTime
              closeOnSelect
              dateFormat="DD/MM/YYYY"
              inputProps={{
              placeholder: 'Date to'
            }}
              onChange={props.onDateToChange}
              timeFormat={false}
              value={props.dateToValue}
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col md={6}>
          <FormGroup>
            <MultiSelect
              controlId="pointsPot"
              data={props.pointsPotList}
              onChange={props.onPointsPotChange}
              value={props.pointsPotValue}
            />
          </FormGroup>
        </Col>
        <Col className="actions" md={6}>
          <Button
            className="red-ghost-btn"
            onClick={props.onSearch}
          >
            Search
          </Button>

          <Button
            className="red-ghost-btn"
            onClick={props.onClear}
          >
            Clear search/filters
          </Button>
        </Col>
      </Row>
    </Card.Body>
  </Card>
);

export default PointsTransactionsSearch;
